/**
 * @file Projectile lifetime (GDD §8).
 *
 * Firing itself belongs to the weapon and to
 * {@link ./WeaponSystem.js WeaponSystem}; what is left here is the rule that
 * outlives any single weapon — a round that has flown its full range stops
 * existing, whatever fired it.
 */

import { System } from '../ecs/System.js';
import { Transform, Projectile } from '../components/index.js';

export class CombatSystem extends System {
  static priority = 30;

  /**
   * @param {number} _dt Delta time in seconds.
   * @returns {void}
   */
  update(_dt) {
    this._updateProjectiles();
  }

  /**
   * Retires projectiles that outran their range (GDD §8). Distance comes from
   * the movement the transform already recorded, so the rule never duplicates
   * the integration maths.
   * @returns {void}
   * @private
   */
  _updateProjectiles() {
    for (const entity of this.world.query(Projectile, Transform)) {
      const projectile = entity.get(Projectile);
      const transform = entity.get(Transform);

      projectile.travelled += transform.position.distanceTo(transform.previousPosition);
      if (projectile.travelled >= projectile.range) this.world.destroyEntity(entity);
    }
  }
}
